import React from 'react';

interface PageTransitionProps {
    className?: string;
    children: React.ReactNode;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ className, children }) => (
    <div className={`anim-fade-in ${className ?? ''}`}>{children}</div>
);
